import request from "@/utils/request";

/**
 * 获取秒杀商品列表
 */
export function getSeckillList() {
  return request.get("/seckill/pclist", { login: false });
}

/**
 * 获取折扣商品列表
 */
export function getDiscountList() {
  return request.get("/discount/list", { login: false });
}

/**
 * 获取优惠商品列表
 */
export function getSpecialList() {
  return request.get("/specialoffer/list", { login: false });
}

/**
 * 获取折扣商品详情
 */
export function getDiscountDetail(id) {
  return request.get("/discount/detail/" + id, {}, { login: true });
}
/**
 * 获取折扣商品详情
 */
export function getSpecialDetail(id) {
  return request.get("/specialoffer/detail/" + id, {}, { login: true });
}
/**
 * 秒杀产品详情
 */
export function getSeckillDetail(id, time) {
  return request.get("/seckill/detail/" + id + "/" + time, {}, { login: true });
}

